import React, { useState, useEffect, useRef, useMemo } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import {
  Button,
  Input,
  Form,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import Swal from "sweetalert2";
import { useHistory, useLocation } from "react-router-dom";
import swal from "@sweetalert/with-react";
import Loader from "../../Forms/ShortCutComponents/ResponseLoader";
import moment from "moment";
import { AppSwitch } from "@coreui/react";
import axios from "axios";
import PurchasePrintView from "../purchasePrintView";
import IssueProdPrintView from "../issueProdPrintView";
import AuthPrintView from "../authPrintView";
import JvPrint from "../../Forms/ShortCutComponents/jvPrint";
import PaymentPrint from "../../Forms/ShortCutComponents/paymentPrint";
import DemandIssuePrint from "../../Forms/demandIssuePrint";
import { baseurl } from "../../../baseurl";
import ImageContaboUpload from "./ImageContaboUpload";
import { check_Bussiness_Permission } from "../../../Helper";
let companyId = localStorage.getItem("companyId");
let username = localStorage.getItem("username");
var token = localStorage.getItem("token");

const AuthorizationTables = (props) => {
  const tableRef = useRef();
  const location = useLocation();
  const { data } = location.state || {};

  console.log("data", data, props);
  const [showModalAddNew, setShowModalAddNew] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState(
    props?.location?.state?.selectedRows || []
  );
  const [authTrackData, setAuthTrackData] = useState({
    pk_Id: props?.location?.state?.selectedRows?.[0]?.pk_id || null,
    book: null,
    branch: null,
    emp_Id: null,
  });
  const [remarks, setRemarks] = useState("");
  // Per-document remarks, keyed by pk_id, so every approval/rejection keeps
  // its own remarks even when several documents are processed in one batch.
  const [remarksMap, setRemarksMap] = useState({});
  const [trackTableData, setTrackTableData] = useState([]);
  const [selectedRowKey, setSelectedRowKey] = useState(null);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [showButtons, setShowButtons] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [attachmentFiles, setAttachmentFiles] = useState(null);
  const [showDoc, setShowDoc] = useState(true);
  const [showAttachment, setShowAttachment] = useState(true);
  const [showAuthTrack, setShowAuthTrack] = useState(true);
  const [company, setCompany] = useState({
    isEggSpectation: false,
    isCrumble: false,
  });

  const history = useHistory();
  useEffect(() => {
    const funCall = async () => await checkBussinessPermission();
    funCall();

    if (tableData && tableData.length > 0) {
      const row = tableData[0];
      setSelectedRowKey(row.pk_id);
      setSelectedRow(row);
      getAuthTrack(row);
      checkDocStatus(row, 1);
    } else {
      props.history.push({
        pathname: "/AuthorizationForm",
      });
    }
  }, []);

  const toggleAddNew = () => {
    console.log(showModalAddNew);
    setShowModalAddNew(!showModalAddNew);
    history.push("/AuthorizationForm");
  };

  // Load the preview + auth track for a row without changing selection.
  const previewRow = (row) => {
    setSelectedRowKey(row.pk_id);
    setSelectedRow(row);
    getAuthTrack(row);
    setAttachmentFiles(null);
    checkDocStatus(row, 1);
  };

  const selectRowProp = {
    mode: "checkbox",
    columnWidth: "5%",
    onSelect: (row, isSelect) => {
      setSelectedKeys((prev) =>
        isSelect ? [...prev, row.pk_id] : prev.filter((k) => k !== row.pk_id)
      );
      // Always show the clicked row's preview so it can be reviewed, whether
      // it was just selected or deselected.
      previewRow(row);
    },
    onSelectAll: (isSelect, rows) => {
      setSelectedKeys(isSelect ? rows.map((r) => r.pk_id) : []);
      if (isSelect && rows.length > 0) {
        previewRow(rows[0]);
      }
      return true;
    },
    // Clicking anywhere on the row toggles its selection (big click target,
    // not just the tiny checkbox); onSelect also opens its preview.
    clickToSelect: true,
    bgColor: function (row, isSelect) {
      if (isSelect || row.pk_id === selectedRowKey) {
        return "#d9d9d9";
      }
      return null;
    },
    selected: selectedKeys,
    style: {
      display: "inline-block !important",
    },
  };
  function dueFormatorsComma(cell, row, enumObject, index) {
    let cett = "";
    if (cell) {
      cett = cell?.toLocaleString("en-US", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    } else {
      cett = 0;
    }
    return cett;
  }

  const getAuthTrack = async (row) => {
    setIsLoading(true);
    const { inv_book_id, sub_inv_id, pk_id } = row;
    try {
      const response = await axios.post(
        `${baseurl}/lovs/am_AuthTrack`,
        {
          companyId: companyId,
          pk_id: pk_id,
          inv_book_id: inv_book_id ? inv_book_id : null,
          sub_inv_id: sub_inv_id ? sub_inv_id : null,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        },
      );

      let getItemData = response.data.data;
      console.log("helllo", getItemData);
      setAuthTrackData((prev) => ({
        ...prev,
        pk_Id: pk_id,
        book: inv_book_id,
        branch: sub_inv_id,
        emp_Id: response.data.emp_id,
      }));
      setTrackTableData(getItemData);

      setIsLoading(false);
      // setSelectedRow(null);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data:", error);
    }
  };
  const authApproved = async (authCheck) => {
    const { pk_Id, book, branch, emp_Id } = authTrackData;
    if (authCheck === 0 && !remarks.trim()) {
      swal({
        title: "Warning!",
        text: "Remarks are required for rejection.",
        icon: "warning",
      });
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${authCheck ? "Approve" : "Reject"} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        try {
          const response = await axios.post(
            `${baseurl}/lovs/am_AuthCheck`,
            {
              companyId: companyId,
              pk_Id,
              inv_book_id: book ? book : null,
              sub_inv_id: branch ? branch : null,
              emp_Id,
              authCheck,
              username: username,
              remarks: remarks.trim() === "" ? null : remarks,
            },
            {
              headers: {
                authorization: token,
              },
            },
          );

          let getItemData = response.data.data;

          if (getItemData === 1 || getItemData === 2) {
            swal({
              title: "Success!",
              text: `This document is ${getItemData === 1 ? 'rejected' : 'approved'} by you!`,
              icon: "success",
            });
            const updatedTableData = tableData.filter((doc) => doc.pk_id !== pk_Id);

            setTableData(updatedTableData);
            setShowButtons(false);
            setRemarks("");

            if (updatedTableData.length === 0) {
              setSelectedRow(null);
              setSelectedRowKey(null);
              setTimeout(() => {
                history.push("/authorizationForm");
              }, 2000);
            } else {
              const nextRow = updatedTableData[0];
              setSelectedRow(nextRow);
              setSelectedRowKey(nextRow.pk_id);
              getAuthTrack(nextRow);
              checkDocStatus(nextRow, 1);
            }
          } else {
            swal({
              title: "Rejected!",
              text: "already rejected!",
              icon: "warning",
            });
            setShowButtons(false);
          }
          setIsLoading(false);
        } catch (error) {
          setIsLoading(false);
          swal({
    title: "Error!",
    text: error.response?.data?.message || error.message || "Request failed",
    icon: "error",
  });
          console.error("Error fetching data:", error);
        }
      }
    });
  };
  // Bulk approve/reject every checked document in a single request. This
  // avoids reloading the heavy per-document preview between each approval,
  // which is what made approving many documents take several minutes each.
  const authApprovedBatch = async (authCheck) => {
    const docs = tableData.filter((d) => selectedKeys.includes(d.pk_id));
    if (docs.length === 0) {
      swal({
        title: "Warning!",
        text: "Please select at least one document.",
        icon: "warning",
      });
      return;
    }
    // Rejection requires remarks for EACH document being rejected.
    if (authCheck === 0) {
      const missing = docs.filter((d) => !(remarksMap[d.pk_id] || "").trim());
      if (missing.length > 0) {
        swal({
          title: "Warning!",
          text: `Remarks are required for rejection. ${missing.length} selected document(s) have no remarks. Click a document to add its remarks.`,
          icon: "warning",
        });
        // Bring the first document missing remarks into the preview so the
        // reviewer can fill it in immediately.
        previewRow(missing[0]);
        return;
      }
    }
    Swal.fire({
      title: "Are you sure?",
      text: `You are about to ${authCheck ? "approve" : "reject"} ${docs.length} document(s). You won't be able to revert this!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${authCheck ? "Approve" : "Reject"} them!`,
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      setIsLoading(true);
      try {
        const response = await axios.post(
          `${baseurl}/lovs/am_AuthCheckBatch`,
          {
            companyId: companyId,
            username: username,
            authCheck,
            docs: docs.map((d) => ({
              pk_Id: d.pk_id,
              inv_book_id: d.inv_book_id || null,
              sub_inv_id: d.sub_inv_id || null,
              remarks: (remarksMap[d.pk_id] || "").trim() || null,
            })),
          },
          {
            headers: {
              authorization: token,
            },
          },
        );

        const results = response.data.data || [];
        const okIds = results.filter((r) => r.ok).map((r) => r.pk_Id);
        const failed = results.filter((r) => !r.ok);

        const updatedTableData = tableData.filter(
          (doc) => !okIds.includes(doc.pk_id)
        );
        setTableData(updatedTableData);
        setSelectedKeys([]);
        setShowButtons(false);
        setRemarks("");
        // Drop remarks for the documents that were processed.
        setRemarksMap((prev) => {
          const next = { ...prev };
          okIds.forEach((id) => delete next[id]);
          return next;
        });

        let msg = `${okIds.length} document(s) ${authCheck ? "approved" : "rejected"} successfully.`;
        if (failed.length > 0) {
          msg +=
            ` ${failed.length} could not be processed` +
            (failed[0]?.message ? ` (e.g. ${failed[0].message})` : "") +
            ".";
        }
        swal({
          title: failed.length === 0 ? "Success!" : "Partially completed",
          text: msg,
          icon: failed.length === 0 ? "success" : "warning",
        });

        if (updatedTableData.length === 0) {
          setSelectedRow(null);
          setSelectedRowKey(null);
          setTimeout(() => {
            history.push("/authorizationForm");
          }, 2000);
        } else {
          const nextRow = updatedTableData[0];
          previewRow(nextRow);
        }
      } catch (error) {
        swal({
          title: "Error!",
          text:
            error.response?.data?.message ||
            error.message ||
            "Request failed",
          icon: "error",
        });
        console.error("Error in bulk authorization:", error);
      } finally {
        setIsLoading(false);
      }
    });
  };

  const checkDocStatus = async (authCheck, checkMainYn) => {
    const { pk_Id, book, branch, emp_Id, inv_book_id, pk_id, sub_inv_id } =
      authCheck;
    console.log("aaaaaaaaa=====", authCheck);
    // setIsLoading(true);
    try {
      const response = await axios.post(
        `${baseurl}/Authorizer/checkDocStatus`,
        {
          companyId: companyId,
          document_id: pk_Id || pk_id,
          book_id: book || inv_book_id ? book || inv_book_id : null,
          sub_inv_id: branch || sub_inv_id ? branch || sub_inv_id : null,
          emp_Id,
          authCheck,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        },
      );

      let getItemData = response.data.data;
      if (getItemData.already_marked_yn) {
        swal({
          title: "Info!",
          text: `You ${checkMainYn ? "already" : ""} marked this document!`,
          icon: checkMainYn ? "info" : "success",
        });
        setShowButtons(false);
      } else {
        setShowButtons(true);
      }
      // setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const handleDynamicAttachmentUpdate = async (files) => {
    setAttachmentFiles(files);

    if (!selectedRow) return;

    try {
      const payload = {
        companyId: companyId,
        username: username,
        inv_book_id: selectedRow.inv_book_id,
        pk_id: selectedRow.pk_id,
        attachment_file: files,
      };

      const res = await axios.post(
        `${baseurl}/contaboImages/addAttachmentFromAuth`,
        payload,
        {
          headers: { authorization: token },
        }
      );

      if (res.data.success) {
        setSelectedRow((prev) => ({ ...prev, attachment_file: files }));
        setTableData((prevTableData) =>
          prevTableData.map((row) =>
            row.pk_id === selectedRow.pk_id
              ? { ...row, attachment_file: files }
              : row
          )
        );
      }
    } catch (err) {
      console.error("Failed to update attachment", err);
    }
  };

  const checkBussinessPermission = async () => {
    let checkBussinessPermission = await check_Bussiness_Permission();
    let { isEggSpectation } = checkBussinessPermission;
    if (isEggSpectation) {
      setCompany({ isEggSpectation: true });
    }
  };


const vendorNameFormatter = (cell) => {
    return <div>{cell ? cell : "-"}</div>;
  };
  const options = {
    // paginationShowsTotal: true,
    // page: 1,
    sizePerPage: 5, // This will show 5 rows at a time
    // pageStartIndex: 1,
    // paginationSize: 5,
    // prePage: "Prev",
    // nextPage: "Next",
    // firstPage: "First",
    // lastPage: "Last",
    // prePageTitle: "Go to previous",
    // nextPageTitle: "Go to next",
    // firstPageTitle: "Go to first",
    // lastPageTitle: "Go to Last",
    // paginationPosition: "top",
    // sizePerPageList: [
    //   {
    //     text: "5",
    //     value: 5,
    //   },
    //   {
    //     text: "10",
    //     value: 10,
    //   },
    //   {
    //     text: "30",
    //     value: 30,
    //   },
    //   {
    //     text: "50",
    //     value: 50,
    //   },
    //   {
    //     text: "All",
    //     value: table.OverViewDataTable?.length,
    //   },
    // ],
  };

  const { isEggSpectation } = company || {};

  // Memoize the heavy document preview so it only rebuilds when the previewed
  // document (or the Show/Hide toggle) changes. Without this, typing in the
  // remarks box re-rendered the whole print view on every keystroke and froze
  // the page.
  const documentPreview = useMemo(() => {
    if (!selectedRow || !showDoc) return null;
    return (
      <div className="mt-2 border mb-2 py-2 px-4">
        {selectedRow?.document_type == "Other Payment" ? (
          <JvPrint
            key={selectedRow.pk_id}
            oth_pr_id={selectedRow.pk_id}
            inv_book_id={selectedRow.inv_book_id}
            fromAuth={true}
          />
        ) : selectedRow?.document_type == "Issue Note" ? (
          <IssueProdPrintView
            key={selectedRow.pk_id}
            id={selectedRow.pk_id}
            headerPrefix={selectedRow?.document_type}
            inv_book_id={selectedRow.inv_book_id}
            fromAuth={true}
          />
        ) : selectedRow?.document_type == "Supply Payments" ? (
          <PaymentPrint
            key={selectedRow.pk_id}
            id={selectedRow.pk_id}
            inv_book_id={selectedRow.inv_book_id}
            fromAuth={true}
          />
        ) : selectedRow?.document_type == "Demand Issue" ? (
          <DemandIssuePrint
            key={selectedRow.pk_id}
            id={selectedRow?.pk_id}
            headerPrefix={selectedRow?.document_type}
            authCheck={true}
          />
        ) : (
          <PurchasePrintView
            key={selectedRow.pk_id}
            id={selectedRow?.pk_id}
            headerPrefix={selectedRow?.document_type}
            authCheck={true}
          />
        )}
      </div>
    );
  }, [selectedRow, showDoc]);

  // Same reasoning as documentPreview: keep the attachment uploader from
  // re-rendering (and re-fetching its image) on every remarks keystroke.
  const attachmentPreview = useMemo(() => {
    if (!selectedRow || !showAttachment || !isEggSpectation) return null;
    return (
      <ImageContaboUpload
        key={selectedRow.pk_id}
        isDisabled={false}
        existingFileKey={selectedRow.attachment_file}
        isViewMode={false}
        allowDelete={false}
        moduleType={selectedRow.document_type}
        toggleAddNew={handleDynamicAttachmentUpdate}
      />
    );
    // handleDynamicAttachmentUpdate closes over selectedRow, which is a dep.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRow, showAttachment, isEggSpectation]);

  return (
    <>
      {/* <Modal
        isOpen={showModalAddNew}
        size="xl"
        toggle={toggleAddNew}
        backdrop="static"
      >
        <ModalHeader
          toggle={toggleAddNew}
          className="Creative-Invoice-header-styling"
        >
          <strong>
            <h4>Authorization</h4>
          </strong>
        </ModalHeader>
        <ModalBody> */}
      <>
        <div className="row d-flex justify-content-between align-items-center mb-2">
          <div className="col-md-6 h3">Authorization</div>
          <div className="col-md-6 d-flex justify-content-end">
            <Button
              color="secondary"
              className="rounded-pill"
              onClick={() => history.push("/authorizationForm")}
            >
              <i className="fa fa-arrow-left pr-2"></i> Back
            </Button>
          </div>
        </div>
        <div className="border p-1">
          <BootstrapTable
            // keyField="pk_id"
            data={tableData}
            selectRow={selectRowProp}
            striped
            hover
            // search
            tableHeaderClass="rpr_header"
            tableBodyClass="rpr_body"
            containerClass="rpr_container"
            options={{
              ...options,
              pagination: false, // Disable pagination
              noDataText: "No records found",
            }}
            ref={tableRef}
            headerStyle={{
              position: "sticky",
              top: "0",
              //  zIndex: "1000"
            }}
            maxHeight="300px" // Adjust this value to show exactly 5 rows
          >
            <TableHeaderColumn
              dataAlign="center"
              dataField="pk_id"
              className="rpr_header"
              width="5%"
              dataSort={true}
              isKey={true}
              hidden
            >
              id
            </TableHeaderColumn>
            <TableHeaderColumn
                  dataAlign="center"
                  dataField="vendor_name" 
                  className="rpr_header"
                  width="15%"
                  dataSort={true}
                  hidden={!selectedRow?.vendor_name} 
                  dataFormat={vendorNameFormatter}
                >
                  Vendor Name
                </TableHeaderColumn>
            <TableHeaderColumn
              dataAlign="center"
              dataField="document_name"
              className="rpr_header"
              width="15%"
              dataSort={true}
            >
              Doucment Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataAlign="center"
              dataField="date"
              width="10%"
              className="rpr_header"
              dataFormat={(date) =>
                date ? moment(date).format("DD-MMM-YYYY") : "N/A"
              }
              dataSort={true}

            >
              Date
            </TableHeaderColumn>

            <TableHeaderColumn
              dataAlign="center"
              dataField="doc_no"
              className="rpr_header"
              width="10%"
              dataSort={true}
            >
              Doc No
            </TableHeaderColumn>
            <TableHeaderColumn
              dataAlign="center"
              dataField="total_amount"
              className="rpr_header"
              width="10%"
              dataFormat={dueFormatorsComma}
              dataSort={true}
            >
              Amount
            </TableHeaderColumn>
            <TableHeaderColumn
              dataAlign="center"
              dataField="delivery_date"
              className="rpr_header"
              width="10%"
              dataFormat={(delivery_date) =>
                delivery_date ? delivery_date : "N/A"
              }
              dataSort={true}
            >
              Receipt Time
            </TableHeaderColumn>
            <TableHeaderColumn
              dataAlign="center"
              dataField="status"
              className="rpr_header"
              width="15%"
            >
              Status
            </TableHeaderColumn>
          </BootstrapTable>
          <div className="row ">
            <div className="col-md-6 col-lg-6 mt-3 ">
              <Label>
                Approval/rejection Remarks
                {selectedRow?.doc_no ? (
                  <span className="text-muted"> (for Doc No: {selectedRow.doc_no})</span>
                ) : null}
                {/* <span className="text-danger">*</span> */}
              </Label>
              <Input
                type="text"
                className="form-control  "
                name="TeamDesc"
                id="TeamDesc"
                disabled={!selectedRowKey}
                placeholder={
                  selectedRowKey
                    ? "Enter remarks for the selected document"
                    : "Select a document to add its remarks"
                }
                value={remarksMap[selectedRowKey] || ""}
                onChange={(e) => {
                  // Capture the value synchronously: the functional state
                  // updater below runs later, by which time React 16 has
                  // recycled the synthetic event and e.target would be null.
                  const value = e.target.value;
                  const key = selectedRowKey;
                  setRemarksMap((prev) => ({
                    ...prev,
                    [key]: value,
                  }));
                }}
              // required
              />
            </div>
            <div className="col-md-6 col-lg-6 mt-3 ">
              <div className="d-flex  justify-content-end align-items-center gap-2">
                <div className="mt-2 ">
                  <Button
                    color="info"
                    outline
                    className="rounded-pill mx-2"
                    disabled={tableData.length === 0}
                    onClick={() =>
                      setSelectedKeys(
                        selectedKeys.length === tableData.length &&
                          tableData.length > 0
                          ? []
                          : tableData.map((d) => d.pk_id)
                      )
                    }
                  >
                    {selectedKeys.length === tableData.length &&
                    tableData.length > 0
                      ? "Clear"
                      : `Select All (${tableData.length})`}
                  </Button>
                </div>
                {selectedKeys.length > 0 && (
                  <>
                    <div className="mt-2 ">
                      <Button
                        onClick={() => authApprovedBatch(1)}
                        className="btn btn-success rounded-pill mx-2"
                      >
                        Approve Selected ({selectedKeys.length})
                      </Button>
                    </div>
                    <div className="mt-2 ">
                      <Button
                        onClick={() => authApprovedBatch(0)}
                        className="btn btn-warning rounded-pill mx-2"
                      >
                        Reject Selected ({selectedKeys.length})
                      </Button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>{" "}
        </div>
        {/* <div className="d-flex mb-2">
          <div className="d-flex  offset-md-7 offset-lg-7 "> 
            <div className="mt-2 ">
              <Button
                onClick={() => authApproved(1)}
                className="btn btn-success rounded-pill mx-2"
              >
                Approved
              </Button>
            </div>
            <div className="mt-2 ">
              <Button
                onClick={() => authApproved(0)}
                className="btn btn-warning rounded-pill mx-2"
              >
                Reject
              </Button>
            </div>
          </div>
        </div> */}

        {/* <h5 className="p-2 mt-1 mb-0 bg-info text-dark ">
            Detail Part authorization
          </h5>
          <div className="border p-1">
            <BootstrapTable
              // data={tableData}
              striped
              // pagination
              hover
              // search
              tableHeaderClass="rpr_header"
              tableBodyClass="rpr_body"
              containerClass="rpr_container"
              // options={options}
            >
              <TableHeaderColumn
                dataField="sr"
                dataAlign="center"
                width="5%"
                dataSort={true}
                isKey={true}
              >
                Sr#
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="item_code"
                dataAlign="center"
                width="5%"
              >
                Item Code
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="item_desc"
                dataAlign="center"
                width="10%"
              >
                Item Desc
              </TableHeaderColumn>
              <TableHeaderColumn dataField="uom" dataAlign="center" width="5%">
                Uom
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="primary_qty"
                dataAlign="right"
                width="7%"
                dataFormat={dueFormatorsComma}
              >
                Primary Qty
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="last_purchase_rate"
                dataAlign="right"
                width="10%"
                dataFormat={dueFormatorsComma}
              >
                Last Purchase Rate
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="current_rate"
                dataAlign="right"
                width="7%"
                dataFormat={dueFormatorsComma}
              >
                Current Rate
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="amount"
                dataAlign="right"
                width="7%"
                dataFormat={dueFormatorsComma}
              >
                Amount
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="line_remarks"
                dataAlign="center"
                width="10%"
              >
                Line Remarks
              </TableHeaderColumn>
            </BootstrapTable>
          </div> */}
        {/* <h5 className="p-2 mt-2 mb-0 bg-info text-dark ">
          Authorization Track
        </h5> */}
        <div className="row p-2 bg-info mt-2 mx-1">
          <div className="col-6">
            <h5 className=" mt-2 mb-0 text-dark ">Authorization Track</h5>
          </div>
          <div className="col-6" style={{ textAlign: "right" }}>
            <AppSwitch
              className="mx-1 "
              onClick={() => setShowAuthTrack(!showAuthTrack)}
              variant="pill"
              size="lg"
              color="primary"
              label={showAuthTrack ? "Show" : "Hide"}
              checked={showAuthTrack}
            />
          </div>
        </div>
        {isLoading === true ? (
          <Loader />
        ) : showAuthTrack === true ? (
          <div className="border p-1">
            <BootstrapTable
              data={trackTableData}
              striped
              // pagination
              hover
              // search
              tableHeaderClass="rpr_header"
              tableBodyClass="rpr_body"
              containerClass="rpr_container"
              trStyle={(row) => {
                if (row?.status?.toLowerCase() === "approved") {
                  return { backgroundColor: "#d4edda" }; // light green
                } else if (row?.status?.toLowerCase() === "rejected") {
                  return { backgroundColor: "#f8d7da" }; // light red
                }
                return {};
              }}
            // options={options}
            >
              <TableHeaderColumn
                dataField="emp_name"
                dataAlign="center"
                width="25%"
                dataSort={true}
                isKey={true}
              >
                Employee
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="Auth_remarks"
                dataAlign="center"
                width="40%"
              >
                Remarks
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="approved_datetime"
                dataAlign="center"
                width="15%"
              >
                Date Time
              </TableHeaderColumn>
              {/* <TableHeaderColumn
                dataField="approval_date_time"
                dataAlign="center"
                width="10%"
              >
                Approval Date Time
              </TableHeaderColumn> */}
              <TableHeaderColumn
                dataField="status"
                dataAlign="right"
                width="20%"
              >
                Status
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        ) : null}

        <div className="row p-2 bg-info mt-2 mx-1">
          <div className="col-6">
            <h5 className=" mt-2 mb-0 text-dark ">Document</h5>
          </div>
          <div className="col-6" style={{ textAlign: "right" }}>
            <AppSwitch
              className="mx-1 "
              onClick={() => setShowDoc(!showDoc)}
              variant="pill"
              size="lg"
              color="primary"
              label={showDoc ? "Show" : "Hide"}
              checked={showDoc}
            />
          </div>
        </div>
        {documentPreview}
        {/* <div className="row p-2 bg-info mt-2 mx-1">
          <div className="col-6">
            <h5 className=" mt-2 mb-0 text-dark ">Attachments</h5>
          </div>
          <div className="col-6" style={{ textAlign: "right" }}>
            <AppSwitch
              className="mx-1 "
              onClick={() => setShowAttachment(!showAttachment)}
              variant="pill"
              size="lg"
              color="primary"
              label={showAttachment ? "Show" : "Hide"}
              checked={showAttachment}
            />
          </div>
        </div> */}
        {attachmentPreview}
      </>
      {/* </ModalBody>
      </Modal> */}
    </>
  );
};

export default AuthorizationTables;
